import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16.193",
  height: "16.192"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "none",
      stroke: "#626997",
      "stroke-linecap": "round",
      "stroke-width": "1.5",
      "data-name": "* Zamknij 14 x 14"
    }, [
      _createElementVNode("path", {
        d: "m1.096 1.555 14 13.084",
        "data-name": "Path 5810"
      }),
      _createElementVNode("path", {
        d: "m15.098 1.553-14 13.086",
        "data-name": "Path 5811"
      })
    ], -1)
  ]))]))
}
export default { render: render }